import type { CreatePRInput, PurchaseRequisition } from '../types/purchase.types';
import { api, qs } from '../../../renderer/services/http';

export const prService = {
  getAll: async (filters?: { status?: string }) =>
    api<PurchaseRequisition[]>(`/api/purchase/requisitions${qs({ status: filters?.status })}`),

  getById: async (id: string) => api<PurchaseRequisition>(`/api/purchase/requisitions/${id}`),

  create: async (input: CreatePRInput, status: PurchaseRequisition['status'] = 'draft') =>
    api('/api/purchase/requisitions', { method: 'POST', body: JSON.stringify({ ...input, status }) }),

  submit: async (id: string) => api(`/api/purchase/requisitions/${id}/submit`, { method: 'POST' }),

  approve: async (id: string, approvedBy: string) =>
    api(`/api/purchase/requisitions/${id}/approve`, {
      method: 'POST',
      body: JSON.stringify({ approved_by: approvedBy }),
    }),

  reject: async (id: string, reason: string) =>
    api(`/api/purchase/requisitions/${id}/reject`, {
      method: 'POST',
      body: JSON.stringify({ reason }),
    }),
};
